export default __webpack_public_path__ + "static/ProValue_6-860239ee6052718a1d5e4de5f316d21c.webp";